<template>
  <slot v-if="isShow"></slot>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'RequireAccess',
  props: {
    action: {
      type: String,
      default: null,
    },
    data: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    ...mapGetters(['userData']),
    ...mapState(['selectedCompany', 'isRulesLoaded']),
  },
  created() {
    this.handleCan()
  },
  watch: {
    selectedCompany: 'handleCan',
    isRulesLoaded: 'handleCan',
  },
  methods: {
    async handleCan() {
      if (!this.isRulesLoaded) {
        this.isShow = false
        return
      }

      this.isShow = false

      if (this.action && this.data) {
        try {
          this.isShow = await this.$authorizer.can(
            this.action,
            this.data,
            this.userData.UserID?.toString(),
            this.selectedCompany
          )
        } catch (e) {
          console.error('ACL error in RequireAccess:', e)
          this.isShow = false
        }
      } else {
        this.isShow = true
      }
    },
  },
}
</script>
